import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Award } from 'lucide-react';
import { getWorkAnniversaries } from '../../../services/dashboardService';
import { Card, CardHeader, CardTitle, CardBadge, ListItem, Avatar, ListItemContent, ListItemName, ListItemSub, ListItemBadge, EmptyState, ScrollList } from '../styles';

export default function AnniversaryCard() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    getWorkAnniversaries().then(res => {
      const d = res.data?.data;
      setItems(Array.isArray(d) ? d : []);
    });
  }, []);

  return (
    <Card $delay="0.3s">
      <CardHeader>
        <CardTitle>{t('dashboard.workAnniversaries')}</CardTitle>
        {items.length > 0 && <CardBadge $bg="#F0FDF4" $color="#16A34A">{items.length}</CardBadge>}
      </CardHeader>
      {items.length === 0 ? (
        <EmptyState>
          <Award size={32} />
          {t('dashboard.noAnniversaries')}
        </EmptyState>
      ) : (
        <ScrollList>
          {items.map(item => {
            const initials = item.fullName?.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
            return (
              <ListItem key={item.id}>
                <Avatar $bg="linear-gradient(135deg, #7C3AED, #A78BFA)">
                  {item.profilePicture ? <img src={item.profilePicture} alt="" /> : initials}
                </Avatar>
                <ListItemContent>
                  <ListItemName>{item.fullName}</ListItemName>
                  <ListItemSub>{item.years} {t('dashboard.years')}</ListItemSub>
                </ListItemContent>
                <ListItemBadge $bg={item.daysUntil === 0 ? '#FEE2E2' : '#F3E8FF'} $color={item.daysUntil === 0 ? '#E53935' : '#7C3AED'}>
                  {item.daysUntil === 0 ? t('dashboard.today') : `${item.daysUntil} ${t('dashboard.days')}`}
                </ListItemBadge>
              </ListItem>
            );
          })}
        </ScrollList>
      )}
    </Card>
  );
}
